import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-4_cameras",
  "use": "n-icon-4_cameras-usage",
  "viewBox": "0 0 50 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 50 40\" id=\"n-icon-4_cameras\"><rect width=\"24\" height=\"19\" fill=\"#66809F\" fill-opacity=\".15\" rx=\"2\" /><rect width=\"24\" height=\"19\" y=\"21\" fill=\"#66809F\" fill-opacity=\".15\" rx=\"2\" /><rect width=\"24\" height=\"19\" x=\"26\" fill=\"#66809F\" fill-opacity=\".15\" rx=\"2\" /><rect width=\"24\" height=\"19\" x=\"26\" y=\"21\" fill=\"#66809F\" fill-opacity=\".15\" rx=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol